import { Notifications, QuickLinks } from '.'
import { RFI } from '../../CIMSModule/instances'
import { CIMSPageItem } from '../CIMSPageItem'

export const RFITracker = new CIMSPageItem({
  id: '6052599b-513a-4bb3-9d59-94aee8c3256a',
  name: 'RFI Tracker',
  pathname: 'tracker',
  module: RFI,
  linkable: true,
})

export const RFIOrganizations = new CIMSPageItem({
  id: '2150884a-8bb5-4f0a-8368-417aa27d8e40',
  name: 'Organizations',
  pathname: 'organizations',
  module: RFI,
})

export const RFIResponseDisciplines = new CIMSPageItem({
  id: 'c5608280-2808-43e9-970a-c1c57260b731',
  name: 'Response Disciplines',
  pathname: 'response-disciplines',
  module: RFI,
})

export const RFIQuickLinks = QuickLinks({
  id: 'b35dcb67-1aec-4df7-8980-3a7acdeb7b63',
  module: RFI,
})

export const RFINotifications = Notifications({
  id: '1dabd534-4ced-4ccd-b313-bb4d9c6d9e05',
  module: RFI,
})

export type RFIPageItem =
  | typeof RFITracker
  | typeof RFIOrganizations
  | typeof RFIResponseDisciplines
  | typeof RFIQuickLinks
  | typeof RFINotifications
